export default {
    blockui: {
        root: 'relative',
        mask: 'bg-black/40'
    }
}

